import React from "react"
import { Provider } from "react-redux"

import store from "./src/redux/store"
import { __prod__ } from "src/constants.js"

import { Helmet } from "react-helmet"

// Conditionally import Apollo (not available during SSR due to null-loader)
const isBrowser = typeof window !== "undefined"
let ApolloProvider = null
let client = null

if (isBrowser) {
    try {
        ApolloProvider = require("react-apollo").ApolloProvider
        client = require("./src/apollo/client").default
    } catch (e) {
        // Apollo not available during SSR
    }
}

export default ({ element }) => {
    const inner = (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>
                    {__prod__
                        ? "Pracownia Sushi Wola"
                        : "Pracownia Sushi Wola - dev"}
                </title>
                <meta
                    name="theme-color"
                    content="#000000"
                    media="(prefers-color-scheme: light)"
                />
                <meta
                    name="theme-color"
                    content="#000000"
                    media="(prefers-color-scheme: dark)"
                />
            </Helmet>
            <Provider store={store}>{element}</Provider>
        </>
    )

    if (ApolloProvider && client) {
        return <ApolloProvider client={client}>{inner}</ApolloProvider>
    }

    return inner
}
